import React from "react";
import { connect } from "react-redux";
import { Form, Button, Col, Row } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import Select from "react-select";
import Cookies from "js-cookie";
import * as yup from "yup";
import CurrencyInput from "react-currency-input-field";

import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import * as Constants from "../../../../constants/Constants";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import * as Validations from "../../../../utils/validations/validations";
import * as Validator from "../../../../utils/validations/validator";
import { ToolTip } from "../../../Common/Tooltip/ToolTip";
import {
  httpGetVendorStatusDetails,
  httpGetValidateDunsAndCorpName,
  httpPostUpdateVendorProfileInfo,
  httpPostRequestDEIApproval,
  httpGetDownloadFileByVendorId,
  httpPutUpdateDocDetailsByContractType,
} from "../../../../service/httpClient";
import OnSubmitErrorMessage from "../../../Common/Errors/OnSubmitErrorMessage";
import Fields, {
  CompanyBrandName,
  CompanyBrandUrl,
  DeleteBrand,
  MBEWBEFields,
  MBEWBEContractCheck,
} from "./CompanyDetailFields";
import "../../../Common/Tooltip/ToolTip.css";
import "./style.css";
import AppContext from "../../../../context/appcontext";
import {
  getUserRolePermission,
  verifyAccessPermission,
} from "../../../../utils/rolePermissionAccess";
import {
  checkOnBoardingStatus,
  checkUserRoles,
  isMerchantEmailValid,
  isEmailValid,
} from "../../../../utils/utils";
import AddSecondUserModal from "./AddSecondUser";
import ExternalCompanyDetailsModal from "./ExternalCompanyDetailsModal";
import DunsWrapper from "../../../Common/DunsWrapper/DunsWrapper";
import { updateCommonInfo } from "../../../../redux/commonSlice";
import {
  updateVendorProfileDetails,
  updateMerchantDetails,
  updateServiceData,
} from "../../../../redux/serviceSlice";
import DynamicOptions from "./DynamicOptions";
import ConfirmationModal from "../../../Common/ConfirmationModal";
import {
  formatPhone,
  transformValue,
  isValidateDateField,
} from "../../OnboardingHelper";
import ConfigOptions from "./ConfigOptions";

const _ = require("lodash");

class Company extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      validators: {
        openRANumeric: {
          message: "The Open RA number must be a number.",
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^(\s*|\d+)$/);
          },
          required: false,
        },
        brandNameValidator: {
          message:
            "The following special character is not valid for Brand Name",
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^[^|]+$/g);
          },
          required: true,
        },
        brandUrlValidator: {
          message:
            "Invalid URL. Please enter in the following format: https://www.example.com",
          rule: (val, params, validator) => {
            let regex = /^($)|(https?:\/\/(?:www\.[^.])[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^.][^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^.][^\s]{2,}|https?:\/\/(?:www\.[^.])[a-zA-Z0-9]\.[^\s]{2,}|(www\.[^.])[a-zA-Z0-9]\.[^.][^\s]{2,})/;
            let validated = validator.helpers.testRegex(val, regex);
            if (val && validated) {
              let str = val.replace(/http:\/\/|https:\/\//gi, "");
              return str.split(".")[0].length === 3;
            }
            return !val ? true : false;
          },
          required: true,
        },
        emailRegex: {
          message: Constants.VALID_EMAIL_ERROR_MSG,
          rule: (val) => {
            const splitVal = val !== undefined && val?.split("@")[0];
            return isMerchantEmailValid(splitVal);
          },
          required: true,
        },
        emailMerchantRegex: {
          message: Constants.MERCHANT_EMAIL_ERROR_MSG,
          rule: (val) => {
            const splitVal = val !== undefined && val?.split("@")[1];
            return splitVal === "macys.com" || splitVal === "bloomingdales.com";
          },
          required: true,
        },
        merchantFirstNameRegex: {
          message: Constants.MERCHANT_FIRST_NAME_ERROR_MSG,
          rule: (val) => {
            const regex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;
            return regex.test(val);
          },
          required: true,
        },
        merchantLastNameRegex: {
          message: Constants.MERCHANT_LAST_NAME_ERROR_MSG,
          rule: (val) => {
            const regex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;
            return regex.test(val);
          },
          required: true,
        },
      },
    });

    this.state = {
      isInternalUser: false,
      disableContinueButton: false,
      brandErrors: false,
      brandUrlErrors: {},
      brandNameErrors: {},
      checkBrandValues: {},
      hasErrorIndex: -1,
      errorStatus: false,
      isDunsValidated: false,
      isResponseRendered: false,
      isOwnVendorProfile: true,
      dunValidationMsg: "",
      corpValidationMsg: "",
      duns: "",
      vendorCorpName: "",
      upsAccountNumber: "",
      numberOfUpcToDropShip: "",
      vendorProfile: this.props.vendorProfile,
      labelMinorityPocInfoMsg: "",
      vendorDetails: {
        duns: "",
        dept: "",
        vendorNumber: "",
        numberOfUpcToDropShip: "",
        certifiedAsMinority: null,
        brandName: "",
        brandUrl: "",
        upsAccountNumber: "",
        vendorCorpName: "",
        openRANumber: "",
        merchandiseType: "",
        status: "",
        primaryContactEmail: "",
        vendorProfileId: null,
        isUPSEnabled: false,
        vendorAddType:
          Cookies.get(Constants.USER_TYPE) === Constants.INTERNAL_UI
            ? Constants.INTERNAL_BACK_END
            : Cookies.get(Constants.USER_TYPE) === Constants.EXTERNAL_UI
            ? Constants.EXTERNAL_BACK_END
            : "",
        isAffidavit: false,
      },
      merchantContact: {
        merchantFirstName: "",
        merchantLastName: "",
        merchantEmail: "",
        merchantId: "",
      },
      brandRecords: [],
      isEditable: false,
      isUPSEnabled: false,
      rolePermissionStatus: false,
      showAddSecondUserModal: false,
      canVendorInitiate: false,
      allowAddProdFulfillmentTypeBtn: true,
      errorMsg: "",
      successMsg: "",
      updateStatus: false,
      externalVendorModal: true,
      showApproveDenyModel: false,
      mbeWbeVendorDetails: {
        federalId: null,
        website: null,
        fax: null,
        ceoEmail: null,
        ceoName: null,
        ceoTitle: null,
        mbeStatus: null,
        wbeStatus: null,
        mbeGroups: null,
        avgEmployees: null,
        avgCompletedSales: null,
        organization: null,
      },
      mbeWbeErrors: {},
      mbeWbeExpireDate: null,
      expirationErrorMsg: "",
    };

    this.onChange = this.onChange.bind(this);
    this.setValue = this.setValue.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.getMbeWbeExpireDate = this.getMbeWbeExpireDate.bind(this);
  }

  componentDidMount() {
    this.setUserAccess();
    this.setMerchantContactsFromProps();
    this.setState({ isResponseRendered: true });
    this.validateVendorStatusByProfileId();
  }

  componentDidUpdate(prevState, prevProps) {
    if (
      prevProps.vendorProfile !== this.props.vendorProfile ||
      (this.props.vendorProfileId &&
        prevProps.vendorProfileId !== this.props.vendorProfileId)
    ) {
      this.state.brandRecords.forEach((item, index) => {
        item.brandUrl &&
          this.showErrorMsg(CompanyBrandUrl.fieldId + index, index, null);
      });

      if (this.props.vendorProfile) {
        if (!_.isNil(this.props.vendorProfile.vendorDetail)) {
          let brandRecords = [];
          let vendorDetail = this.props.vendorProfile[Constants.VENDOR_DETAIL];
          let modifiedBrandName = !_.isNil(vendorDetail["brandName"])
            ? vendorDetail["brandName"].split("|")
            : [];
          let modifiedBrandUrl = !_.isNil(vendorDetail["brandUrl"])
            ? vendorDetail["brandUrl"].split("|")
            : [];
          brandRecords = vendorDetail["brandName"]
            ? [...this.initialDataLoad(modifiedBrandName, modifiedBrandUrl)]
            : [
                {
                  brandName: "",
                  brandUrl: "",
                },
              ];
          this.setState({
            vendorProfile: this.props.vendorProfile,
            vendorDetails: {
              ...vendorDetail,
              certifiedAsMinority: vendorDetail.certifiedAsMinority,
              isAffidavit: vendorDetail?.isAffidavit
                ? vendorDetail?.isAffidavit
                : false,
              vendorAddType: this.props.vendorProfile.vendorDetail.vendorAddType
                ? this.props.vendorProfile.vendorDetail.vendorAddType
                : Cookies.get(Constants.USER_TYPE) === Constants.INTERNAL_UI
                ? Constants.INTERNAL_BACK_END
                : Cookies.get(Constants.USER_TYPE) === Constants.EXTERNAL_UI
                ? Constants.EXTERNAL_BACK_END
                : "",
            },
            vendorProfileId: this.props.vendorProfileId,
            duns: this.props.vendorProfile.vendorDetail.duns,
            numberOfUpcToDropShip: this.props.vendorProfile.vendorDetail
              .numberOfUpcToDropShip,
            vendorCorpName: this.props.vendorProfile.vendorDetail
              .vendorCorpName,
            isDunsValidated: true,
            brandRecords: brandRecords,
            upsAccountNumber: vendorDetail && vendorDetail.upsAccountNumber,
            isUPSEnabled: vendorDetail && vendorDetail.isUPSEnabled,
            isVendorPresent: true,
            isOnChangeVaildDuns: false,
            mbeWbeVendorDetails:
              vendorDetail?.certifiedAsMinority &&
              vendorDetail?.isAffidavit &&
              this.props.vendorProfile.mbeWbeVendorDetails
                ? this.props.vendorProfile.mbeWbeVendorDetails
                : { ...this.state.mbeWbeVendorDetails },
          });
        }
        if (
          this.context &&
          this.context.roles.roleName &&
          this.context.roles.roleName !== Constants.EXTERNAL_VENDOR_GENERIC &&
          this.context.roles.roleName !== Constants.EXTERNAL_GENERIC_ADMIN
        ) {
          this.setState({ isInternalUser: true });
        } else {
          this.setState({ isInternalUser: false });
        }
        this.setMerchantContactsFromProps();
      }
    }

    if (
      !(
        RolePermissionConstants.EDIT ===
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
          RolePermissionConstants.ALL
        )
      )
    ) {
      this.makeformDisable(document.forms.companyDetails);
    }
  }

  validateVendorStatusByProfileId = async () => {
    let apis = [];
    let allowAddProdFulfillmentTypeBtn = false;

    try {
      for (let profile of this.props.profileTypeDetails) {
        /**
         * Skip API call for the selected vendor as the data
         * is already fetched in the OnBoardingContainer
         */

        if (profile.vendorProfileId !== this.props.vendorProfileId) {
          apis.push(httpGetVendorStatusDetails(profile.vendorProfileId));
        }
      }
      const response = await Promise.allSettled(apis);
      /**
       * Check onBoardingStatus of the selected vendor
       * from data available in store.
       */
      for (let data of this.props.vendorStatus) {
        if (
          ![
            Constants.VENDOR_SUBMISSION,
            Constants.VENDOR_REGISTRATION,
            Constants.REJECTED,
          ].includes(data.onboardingStatus.trim())
        ) {
          allowAddProdFulfillmentTypeBtn = true;
          break;
        }
      }

      // Skip if a match is already found for the selected vendor
      if (!allowAddProdFulfillmentTypeBtn) {
        /**
         * Check onBoardingStatus of the other vendors, i.e. primary or secondary
         * from data retrieved via API calls made above.
         */
        for (let { value } of response) {
          if (value && value.status === 200) {
            for (let data of value.data) {
              if (
                ![
                  Constants.VENDOR_SUBMISSION,
                  Constants.VENDOR_REGISTRATION,
                  Constants.REJECTED,
                ].includes(data.onboardingStatus.trim())
              ) {
                allowAddProdFulfillmentTypeBtn = true;
                break;
              }
            }
          }
          // Break the loop if a match is found for one of the primary or secondary vendor
          if (allowAddProdFulfillmentTypeBtn) {
            break;
          }
        }
      }
    } catch (err) {
      console.log(err);
    }

    this.setState({ allowAddProdFulfillmentTypeBtn });
  };

  setUserAccess = () => {
    let rolePermissionFlag;

    if (
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
        RolePermissionConstants.ALL
      ) === RolePermissionConstants.EDIT
    ) {
      rolePermissionFlag = RolePermissionConstants.EDIT;
    } else if (
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
        RolePermissionConstants.ALL
      ) === RolePermissionConstants.VIEW
    ) {
      rolePermissionFlag = RolePermissionConstants.VIEW;
    } else {
      rolePermissionFlag = RolePermissionConstants.NONE;
    }

    this.setState({ rolePermissionStatus: rolePermissionFlag });
  };

  setValue = (e) => {
    let vendorDetail = { ...this.state.vendorDetails };
    const zeroPrependedDuns = Validations.prependDuns(e.target.value);
    vendorDetail["duns"] = zeroPrependedDuns;
    this.setState({ vendorDetails: vendorDetail, duns: zeroPrependedDuns });
  };

  handleCheck = (event) => {
    let vendorProfile = { ...this.state.vendorDetails };

    if (event.target.name === "certifiedAsMinority") {
      if (event.target.value === Constants.YES) {
        vendorProfile[event.target.name] = true;
      } else if (event.target.value === Constants.NO) {
        const mbeWbeVendorDetailsTemp = {
          federalId: null,
          website: null,
          fax: null,
          ceoEmail: null,
          ceoName: null,
          ceoTitle: null,
          mbeStatus: null,
          wbeStatus: null,
          mbeGroups: null,
          avgEmployees: null,
          avgCompletedSales: null,
          organization: null,
        };
        vendorProfile[event.target.name] = false;
        vendorProfile["isAffidavit"] = false;

        this.setState({
          labelMinorityPocInfoMsg: "",
          mbeWbeVendorDetails: mbeWbeVendorDetailsTemp,
          mbeWbeErrors: {},
        });
      }
    } else if (event.target.name === "isUPSEnabled") {
      if (event.target.value === Constants.YES) {
        vendorProfile[event.target.name] = true;
      } else if (event.target.value === Constants.NO) {
        vendorProfile[event.target.name] = false;
      }
    } else if (event.target.name === "isAffidavit") {
      if (event.target.value === "documentUpload") {
        const mbeWbeVendorDetailsTemp = {
          federalId: null,
          website: null,
          fax: null,
          ceoEmail: null,
          ceoName: null,
          ceoTitle: null,
          mbeStatus: null,
          wbeStatus: null,
          mbeGroups: null,
          avgEmployees: null,
          avgCompletedSales: null,
          organization: null,
        };
        this.setState({
          mbeWbeVendorDetails: mbeWbeVendorDetailsTemp,
          mbeWbeErrors: {},
        });
        vendorProfile[event.target.name] = false;
      } else if (event.target.value === "contractUpload") {
        vendorProfile[event.target.name] = true;
      }
    }

    this.setState({ vendorDetails: vendorProfile });
  };

  setMerchantContactsFromProps = () => {
    if (
      this.props.merchantContact &&
      this.props.merchantContact.email !==
        this.state.merchantContact.merchantEmail &&
      this.props.merchantContact.id !== this.state.merchantContact.merchantId
    ) {
      this.setState({
        merchantContact: {
          merchantFirstName: this.props.merchantContact.firstName,
          merchantLastName: this.props.merchantContact.lastName,
          merchantEmail: this.props.merchantContact.email,
          merchantId: this.props.merchantContact.id,
        },
      });
    }
  };

  onChange = (key, e) => {
    let vendorProfile = { ...this.state.vendorDetails };

    let merchantContactDetails = {
      ...this.state.merchantContact,
      primaryVendor: true,
    };
    if (key === "duns") {
      this.setState({ dunValidationMsg: "", dunValidationErrorMsg: "" });
      if (
        Validations.isValidDuns(e.target.value) ||
        e.target.value.length === 0
      ) {
        vendorProfile["duns"] = e.target.value;
        this.setState({
          hasErrorIndex: -1,
          isValidDunsNumber: true,
          isOnChangeVaildDuns: true,
        });
      } else {
        this.setState({
          hasErrorIndex: 13,
          isValidDunsNumber: false,
          dunValidationErrorMsg: Constants.DUNS_VALIDATION_ERROR_MSG,
        });
      }
      this.setState({ duns: e.target.value });
    } else if (key === "vendorCorpName") {
      this.setState({ corpValidationMsg: "" });
      vendorProfile["vendorCorpName"] = e.target.value;
      this.setState({ vendorCorpName: e.target.value });
    } else if (key.indexOf("merchant") > -1) {
      merchantContactDetails[key] = e.target.value;
    } else if (key.indexOf("Upc") > -1) {
      vendorProfile["numberOfUpcToDropShip"] = e.target.value;
      this.setState({ numberOfUpcToDropShip: e.target.value });
    } else if (key.indexOf("merchandiseType") > -1) {
      if (e.target.value !== Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT) {
        vendorProfile["companyType"] = null;
      }
      vendorProfile[key] = e.target.value;
    } else {
      vendorProfile[key] = e.target.value;
    }
    this.setState({
      vendorDetails: vendorProfile,
      merchantContact: merchantContactDetails,
    });
  };

  setMerchantContact = (data) => {
    return {
      vendorProfileId: this.props.vendorProfileId,
      extension: "",
      lastName: data.merchantLastName,
      firstName: data.merchantFirstName,
      category: "Merchant",
      phoneNumber: "",
      role: "Merchant",
      email: data.merchantEmail ? data.merchantEmail.toLowerCase() : "",
      userEmail: this.props.userEmail,
      primaryVendor: true,
      duns: this.state.duns,
      id: data.merchantId,
    };
  };

  onUpdateHandler = (data, merchantContact) => {
    let email = !checkUserRoles([
      Constants.EXTERNAL_VENDOR_GENERIC,
      Constants.EXTERNAL_GENERIC_ADMIN,
    ])
      ? this.props.userEmail
      : Cookies.get("email")
      ? Cookies.get("email").toLowerCase()
      : "";

    let payload = {
      vendorDetails: { ...data },
      merchantContacts: this.setMerchantContact(merchantContact),
      userEmail: email,
      updateUserEmail: Cookies.get("email")
        ? Cookies.get("email").toLowerCase()
        : "",
    };

    if (this.state?.vendorDetails?.certifiedAsMinority) {
      let mbeWbeVendorDetailsTemp = {
        ...this.state?.mbeWbeVendorDetails,
      };
      const addIdDuns = { vendorProfileId: data?.id, duns: data?.duns };

      mbeWbeVendorDetailsTemp = {
        ...mbeWbeVendorDetailsTemp,
        ...addIdDuns,
      };
      payload.mbeWbeVendorDetails = { ...mbeWbeVendorDetailsTemp };
    }

    httpPostUpdateVendorProfileInfo(payload)
      .then((res) => {
        if (res && res.data) {
          this.setState({
            duns: res.data.vendorDetails.duns,
          });
          if (res.data.vendorDetails) {
            localStorage.setItem("vid", res.data.vendorDetails.id);
            localStorage.setItem("duns", res.data.vendorDetails.duns);
            this.props.updateCommonInfo({
              duns: res.data.vendorDetails.duns || "",
              vendorCorpName: res.data.vendorDetails.vendorCorpName || "",
            });
            this.props.updateVendorProfileDetails({
              ...res.data.vendorDetails,
            });
          }
          if (res.data.merchantContacts) {
            this.props.updateMerchantDetails({ ...res.data.merchantContacts });
          }
        }
        this.props.updateServiceData({ fetching: true });
        setTimeout(() => {
          this.setState({
            updateStatus: false,
            errorStatus: false,
            errorMsg: "",
          });
        }, 3000);

        this.props.history.push(
          `/boarding/vendor/address/${res.data.vendorDetails.id}`
        );
      })
      .catch((err) => {
        this.setState({
          errorMsg: "Problem in adding vendor details, try after sometime!",
          errorStatus: true,
          updateStatus: false,
          disableContinueButton: false,
        });
      });
  };

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ disableContinueButton: true });

    let finalBrandRecords = [...this.state.brandRecords];
    let finalBrandName = [];
    let finalBrandUrl = [];

    finalBrandRecords.map((brandRecord) => {
      brandRecord.brandName = brandRecord.brandName
        ? brandRecord.brandName.trim()
        : null;
      finalBrandName.push(brandRecord.brandName);
      finalBrandUrl.push(brandRecord.brandUrl);
    });

    this.setState({
      vendorDetails: {
        ...this.state.vendorDetails,
        brandName: finalBrandName.join("|"),
        brandUrl: finalBrandUrl.join("|"),
      },
    });

    let vendorProfile = {
      ...this.state.vendorDetails,
      brandName: finalBrandName.join("|"),
      brandUrl: finalBrandUrl.join("|"),
      openRANumber: this.state.vendorDetails.openRANumber || null,
    };

    const data = vendorProfile;
    const merchantData = { ...this.state.merchantContact };

    if (this.props.vendorProfile?.vendorDetail?.isPrimaryVendor !== false) {
      this.validateDunsOnSubmit()
        .then((res) => {
          if (res) {
            this.onUpdateHandler(data, merchantData);
            document.dispatchEvent(new CustomEvent("vendorAddedEvent", {}));
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ disableContinueButton: false });
        });
    } else {
      this.onUpdateHandler(data, merchantData);
    }
  }

  getMbeWbeExpireDate = () => {
    if (this.props?.vendorProfileId) {
      httpGetDownloadFileByVendorId(this.props?.vendorProfileId)
        .then((res) => {
          if (res && res.data) {
            let rsMbeWbeDoc = res.data
              .filter((item) => {
                if (
                  item.fileType === Constants.MINORITY_BUSINESS_DOCUMENTATION
                ) {
                  return item;
                }
              })
              .reduce((a, b) => (a.updatedAt > b.updatedAt ? a : b));

            this.setState({
              mbeWbeExpireDate: rsMbeWbeDoc?.expirationDate,
            });
          }
        })
        .catch((err) => {
          this.setState({
            errorMsg: "Problem fetching details, try after sometime!",
            errorStatus: true,
            updateStatus: false,
            disableContinueButton: false,
          });
        });
    }
  };

  handleChangeMbeWbeExpDateField = (dateVal) => {
    let expirationErrorMsg = !isValidateDateField(dateVal)
      ? Constants.MBE_WBE_EXPIRATION_DATE_ERROR_MESSAGE
      : "";
    this.setState({
      mbeWbeExpireDate: dateVal,
      expirationErrorMsg: expirationErrorMsg,
    });
  };

  handleDEIApproval = (deiStatus) => {
    if (!isValidateDateField(this.state?.mbeWbeExpireDate)) {
      this.setState({
        expirationErrorMsg: Constants.MBE_WBE_EXPIRATION_DATE_ERROR_MESSAGE,
      });
      return false;
    }

    let isAffidavit = this.state?.vendorDetails?.isAffidavit;
    if (isAffidavit) {
      this.handleDeiApprovalApiCall(deiStatus);
    } else if (this.state?.mbeWbeExpireDate) {
      let dtUpdtDocDetails = {
        vendorId: this.props?.vendorProfileId,
        expirationDate: this.state?.mbeWbeExpireDate,
      };
      httpPutUpdateDocDetailsByContractType(
        Constants.DEI_TYPE,
        dtUpdtDocDetails
      )
        .then((res) => {
          if (res?.data) {
            this.handleDeiApprovalApiCall(deiStatus);
          }
        })
        .catch((err) => {
          this.setState({
            errorMsg: "Problem in updating details, try after sometime!",
            errorStatus: true,
          });
        });
    }
  };

  handleDeiApprovalApiCall = (deiStatus) => {
    const payload = {
      vendorProfileId: this.props?.vendorProfileId,
      merchApprovedBy: Cookies.get("email"),
      deiStatus: deiStatus,
    };
    httpPostRequestDEIApproval(payload)
      .then((res) => {
        this.props.refreshDataAfterActionSuccessful();
        if (deiStatus === "Deny") {
          this.setState({
            vendorDetails: {
              ...this.state.vendorDetails,
              certifiedAsMinority: false,
            },
          });
        }
      })
      .catch((err) => {
        this.setState({
          errorMsg: "Problem in DEI approval, try after sometime!",
          errorStatus: true,
        });
      });
  };

  isCompanyApproveDenyButtonVisible = () => {
    const { onboardingStatus } = this.props;
    const hasRolePermission =
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
        RolePermissionConstants.VMP_APPROVE_DENY
      ) === RolePermissionConstants.EDIT;
    const hasDEIPendingStatus = checkOnBoardingStatus(onboardingStatus, [
      Constants.DEI_PENDING,
    ]);
    return hasRolePermission && hasDEIPendingStatus ? true : false;
  };

  isCompanyDetailsFlagRuleCompliant = () => {
    const { onboardingStatus } = this.props;
    const allowedStatus = checkOnBoardingStatus(onboardingStatus, [
      Constants.VENDOR_SUBMISSION,
      Constants.VENDOR_REGISTRATION,
      Constants.MERCHANT_APPROVED,
      Constants.DOCUMENT_SUBMITTED,
      Constants.DEI_PENDING,
    ]);
    const hasRolePermission =
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
        RolePermissionConstants.MINORITYFLAG
      ) === RolePermissionConstants.EDIT;
    return allowedStatus || hasRolePermission;
  };

  showError = (type, field, value) => {
    switch (type) {
      case "openRANumeric":
        return this.validator.message(field, value, Validator.OPEN_RA_NUMERIC);
      case "numeric":
        return this.validator.message(field, value, Validator.NUMERIC);
      case "alphaNum":
        return this.validator.message(field, value, Validator.ALPHA_NUM);
      case "alpha":
        return this.validator.message(field, value, Validator.ALPHA);
      case "alphaSpace":
        return this.validator.message(field, value, Validator.ALPHA_SPACE);
      case "req":
        return this.validator.message(field, value, Validator.REQUIRED);
      case "email":
        return this.validator.message(field, value, Validator.EMAIL);
      case "alphaNumSpaceWithMustAlpha":
        return this.validator.message(
          field,
          value,
          "required|" + Validator.ALPHA_NUMERIC_WITH_MUST_ALPHA
        );
      case "alphaNumSpace":
        return this.validator.message(
          field,
          value,
          Validator.ALPHA_NUM_SPACE_DASH
        );
      case "url":
        return this.validator.message(field, value, Validator.URL);
      case "brandNameValid":
        return this.validator.message(field, value, Validator.BRANDNAME);
      case "merchantFirstNameValid":
        return this.validator.message(
          field,
          value,
          Validator.MERCHANTFIRSTNAME
        );
      case "merchantLastNameValid":
        return this.validator.message(field, value, Validator.MERCHANTLASTNAME);
      default:
        break;
    }
  };

  validateDuplicateBrand = (e, index) => {
    let brandRecords = [...this.state.brandRecords];
    let brandErrors = false;
    let keyArray = [];
    let valueArray = [];

    //Make keyArray and valueArray
    brandRecords.map(({ brandName, brandUrl }, index) => {
      keyArray.push(`brandName${index}`);
      valueArray.push(brandName);
      keyArray.push(`brandUrl${index}`);
      valueArray.push(brandUrl);
    });

    //finalize keyArray and valueArray
    let finalArray = [keyArray, valueArray];
    let duplicateIndexes = [];
    finalArray[1].forEach((outerValue, outerIndex) => {
      finalArray[1].forEach((val, index) => {
        if (
          val &&
          outerValue.trim() === val.trim() &&
          outerIndex !== index &&
          duplicateIndexes.indexOf(index) === -1
        ) {
          duplicateIndexes.push(index);
        }
      });
    });

    brandErrors = duplicateIndexes.length > 1;
    this.setState({ brandErrors });
  };

  validateBrandInfo = () =>
    Object.values({
      ...this.state.brandNameErrors,
      ...this.state.brandUrlErrors,
    }).includes(true);

  changeHandlerForBrand = (e, index, attr) => {
    let brandRecords = [...this.state.brandRecords];
    brandRecords[index][attr] = e.target.value;
    this.setState({ brandRecords });
  };

  brandURLChangeHandler = (e, index, attr) => {
    let brandRecords = [...this.state.brandRecords];
    brandRecords[index][attr] = e.target.value;
    this.setState({ brandRecords });
  };

  removeHandler = (e, index) => {
    let brandRecords = [...this.state.brandRecords];

    if (brandRecords.length > 1) {
      brandRecords.splice(index, 1);
    }

    this.setState({ brandRecords }, () => {
      this.validateDuplicateBrand();
      this.validateDuplicateBrand();
    });
  };

  addBrand = () => {
    this.state.brandRecords.length < 50 &&
      this.setState({
        brandRecords: [
          ...this.state.brandRecords,
          {
            brandName: "",
            brandUrl: "",
          },
        ],
      });
  };

  initialDataLoad = (brandNames, brandUrls) => {
    let brandRecords = [...this.state.brandRecords];
    if (!_.isNil(brandNames) && !_.isEmpty(brandNames)) {
      brandRecords = [];
      brandNames.map((name, index) => {
        brandRecords.push({
          brandName: name,
          brandUrl: brandUrls[index] || "",
        });
      });
    } else {
      brandRecords.push({
        brandName: "",
        brandUrl: "",
      });
    }
    return brandRecords;
  };

  showErrorMsg = (field, index, e) => {
    if (!this.validator.fieldValid(field)) {
      this.validator.showMessageFor(field);
      this.setState({ hasErrorIndex: index });
    } else {
      if (field === "duns") {
        this.setValue(this.state.duns);
      } else if (field.indexOf("Upc") > -1) {
        this.setState({
          // numberOfUpcToDropShip: Validations.numberFormat(e.target.value),
          numberOfUpcToDropShip: e.target.value,
        });
      }
      this.setState({ hasErrorIndex: -1 });
    }
  };

  validateDunsOnSubmit = () => {
    return new Promise((resolve, reject) => {
      this.setState({ isResponseRendered: false });
      if (Validations.isValidDuns(this.state.duns) && this.props.userEmail) {
        this.setState({ isValidDunsNumber: true });
        var encodeUserEmail = encodeURIComponent(this.props.userEmail);
        var encodeCorpNm = encodeURIComponent(this.state.vendorCorpName);
        var isPrimaryVendor =
          this.props?.vendorProfile?.vendorDetail?.isPrimaryVendor ===
            undefined ||
          this.props?.vendorProfile?.vendorDetail?.isPrimaryVendor
            ? true
            : false;

        httpGetValidateDunsAndCorpName(
          this.state.duns,
          encodeCorpNm,
          encodeUserEmail,
          isPrimaryVendor
        )
          .then((res) => {
            (res.data.ownVendorProfile === false &&
              res.data.vendorPresent === false) ||
            res.data.ownVendorProfile === true ||
            res.data.vendorPresent === false
              ? resolve(true)
              : reject(false);
            this.setState({
              isOwnVendorProfile: res.data.ownVendorProfile,
              isVendorPresent: res.data.vendorPresent,
              isOnChangeVaildDuns: false,
            });
          })
          .catch((err) => {
            reject(err);
          });
      } else resolve(true);
    });
  };

  validateDunsAlreadyExist = () => {
    this.setState({ isResponseRendered: false });

    if (Validations.isValidDuns(this.state.duns) && this.props.userEmail) {
      this.setState({ isValidDunsNumber: true });

      var encodeUserEmail = encodeURIComponent(this.props.userEmail);
      var encodeCorpNm = encodeURIComponent(this.state.vendorCorpName);
      var isPrimaryVendor =
        this.props?.vendorProfile?.vendorDetail?.isPrimaryVendor ===
          undefined || this.props?.vendorProfile?.vendorDetail?.isPrimaryVendor
          ? true
          : false;

      httpGetValidateDunsAndCorpName(
        this.state.duns,
        encodeCorpNm,
        encodeUserEmail,
        isPrimaryVendor
      )
        .then((res) => {
          if (res && res.data) {
            this.setState({
              isOwnVendorProfile: res.data.ownVendorProfile,
              isVendorPresent: res.data.vendorPresent,
              isOnChangeVaildDuns: false,
            });

            if (res.data.ownVendorProfile) {
              if (res.data.vendorDetail !== null) {
                let modifiedBrandName = !_.isNil(
                  res.data.vendorDetail["brandName"]
                )
                  ? res.data.vendorDetail["brandName"].split("|")
                  : [];

                let modifiedBrandUrl = !_.isNil(
                  res.data.vendorDetail["brandUrl"]
                )
                  ? res.data.vendorDetail["brandUrl"].split("|")
                  : [];

                let brandRecords = [
                  ...this.initialDataLoad(modifiedBrandName, modifiedBrandUrl),
                ];

                if (
                  res.data.vendorDetail.duns === null ||
                  res.data.vendorDetail.duns === ""
                ) {
                  res.data.vendorDetail.duns = this.state.duns;
                }

                this.setState((state) => {
                  let details = { ...res.data.vendorDetail };

                  Object.keys(details).forEach((key) => {
                    details[key] = state.vendorDetails[key]
                      ? state.vendorDetails[key]
                      : details[key];
                  });

                  return {
                    vendorDetails: {
                      ...res.data.vendorDetail,
                      ...details,
                      isUPSEnabled: !!res.data.vendorDetail.isUPSEnabled,
                      certifiedAsMinority:
                        state.vendorDetails["certifiedAsMinority"],
                    },
                    duns: res.data.vendorDetail.duns || this.state.duns,
                    isValidDunsNumber:
                      (res.data.vendorPresent && res.data.ownVendorProfile) ||
                      Validations.isValidDuns(res.data.vendorDetail.duns)
                        ? true
                        : false,
                    hasErrorIndex:
                      (res.data.vendorPresent && res.data.ownVendorProfile) ||
                      Validations.isValidDuns(res.data.vendorDetail.duns)
                        ? -1
                        : 13,
                    numberOfUpcToDropShip: details.numberOfUpcToDropShip,
                    isDunsValidated: true,
                    isVendorPresent: res.data.vendorPresent,
                    dunValidationMsg: Constants.DUNS_VALIDATION_SUCCESS_MSG,
                    corpValidationMsg: Constants.CORP_VALIDATION_SUCCESS_MSG,
                    isResponseRendered: true,
                    vendorCorpName: res.data.vendorDetail.vendorCorpName,
                    upsAccountNumber: res.data.vendorDetail.upsAccountNumber,
                    vendorUPCsProvidedBy:
                      res.data.vendorDetail.vendorUPCsProvidedBy,
                    merchantContact: {
                      duns: res.data.vendorDetail.duns || this.state.duns,
                      merchantFirstName: res.data.merchantContact.firstName,
                      merchantLastName: res.data.merchantContact.lastName,
                      merchantEmail: res.data.merchantContact.email,
                      merchantId: res.data.merchantContact.id,
                      brandRecords: brandRecords,
                    },
                  };
                });
              }
            } else {
              this.setState((state) => ({
                ...state,
                isVendorPresent: res.data.vendorPresent,
                dunValidationMsg: Constants.DUNS_VALIDATION_SUCCESS_MSG,
                corpValidationMsg: Constants.CORP_VALIDATION_SUCCESS_MSG,
                isResponseRendered: true,
                numberOfUpcToDropShip: state.numberOfUpcToDropShip || "",
                vendorDetails: {
                  ...state.vendorDetails,
                  duns: state.vendorDetails.duns,
                  vendorCorpName: state.vendorDetails.vendorCorpName,
                  isUPSEnabled: !!state.vendorDetails.isUPSEnabled,
                  certifiedAsMinority: state.vendorDetails.certifiedAsMinority,
                },
                brandRecords: state.brandRecords.length
                  ? state.brandRecords
                  : [
                      {
                        brandName: "",
                        brandUrl: "",
                      },
                    ],
              }));
              if (
                res.data.vendorPresent &&
                !this.state.isInternalUser &&
                !this.state.isDunsValidated
              ) {
                this.setState({
                  showAddSecondUserModal: true,
                  isDunsValidated: true,
                });
              } else {
                this.setState({ isDunsValidated: true });
              }
            }
          }

          if (!this.state.isOwnVendorProfile && this.state.isVendorPresent) {
            document.forms.companyBasicDetails.reset();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.setState({ isValidDunsNumber: false });
    }
  };

  makeformDisable(forms) {
    if (forms && forms.elements) {
      for (let i = 0; i < forms.elements.length; i++) {
        forms.elements[i].disabled = true;
      }
    }
  }

  makeformEnable(forms) {
    if (forms && forms.elements) {
      for (let i = 0; i < forms.elements.length; i++) {
        forms.elements[i].disabled = false;
      }
    }
  }

  addSecondUserModalCloseHandler = () => {
    if (this.state.canVendorInitiate) {
      this.setState({
        showAddSecondUserModal: false,
        canVendorInitiate: false,
      });
    } else {
      this.setState({
        showAddSecondUserModal: false,
        isDunsValidated: false,
        isVendorPresent: false,
      });
    }
  };

  getDunsCheckMarkSatus = () => {
    return (
      !_.isEmpty(this.state.duns) &&
      this.state.isDunsValidated &&
      this.state.isValidDunsNumber
    );
  };

  getErrorStatus = () => {
    return (
      this.state.isVendorPresent &&
      !this.state.isOwnVendorProfile &&
      !this.state.isOnChangeVaildDuns &&
      Validations.isValidDuns(this.state.duns)
    );
  };

  getDunsValidationStatus = () => {
    const {
      isDunsValidated,
      isValidDunsNumber,
      isOwnVendorProfile,
      isVendorPresent,
      duns,
    } = this.state;
    return (
      !_.isEmpty(duns) &&
      isDunsValidated &&
      isValidDunsNumber &&
      ((!isVendorPresent && !isOwnVendorProfile) ||
        (isVendorPresent && isOwnVendorProfile))
    );
  };
  externalVendorHandler = () => {
    this.setState({
      externalVendorModal: false,
    });
  };

  getFields = (fields, index) => {
    let field = {};

    switch (fields.fieldType) {
      case "text":
        field = (
          <Form.Group
            as={Col}
            md={
              fields.fieldId === "avgEmployees"
                ? 6
                : fields.fieldId === "avgCompletedSales"
                ? 5
                : 4
            }
            key={index}
          >
            <ToolTip
              toolTipId={fields.toolTipId}
              customStyles="compDetailsFormLabel"
              label={fields.fieldLabel}
              mandate={fields.required && Constants.REQUIRED}
              toolTipText={fields.toolTipText}
            />
            <Form.Control
              type={fields.fieldType}
              id={fields.fieldId}
              name={fields.fieldId}
              placeholder={fields.placeHolder}
              maxLength={fields.maxLength}
              value={this.state?.mbeWbeVendorDetails?.[fields.fieldId] || ""}
              onChange={(event) => {
                !fields.required && event.target.value === ""
                  ? this.removeMBEWBEError(fields.fieldId)
                  : this.handleValidation(fields.fieldId, event.target.value);
                this.onChangeMBEWBE(fields.fieldId, event);
              }}
              onBlur={(e) =>
                fields.required &&
                this.handleValidation(fields.fieldId, e.target.value)
              }
              disabled={
                this.props.vendorProfile?.vendorDetail?.isPrimaryVendor ===
                  false || this.isCompanyDetailsFlagRuleCompliant() === false
                  ? true
                  : false
              }
            />

            {this.state?.mbeWbeErrors[fields.fieldId] && (
              <div key={fields.fieldId} style={{ color: "#d64a4a" }}>
                {this.state?.mbeWbeErrors[fields.fieldId]}
              </div>
            )}
          </Form.Group>
        );
        break;
      case "USDNumber":
        field = (
          <Form.Group
            as={Col}
            md={fields.fieldId === "avgCompletedSales" ? 5 : 4}
            key={index}
          >
            <ToolTip
              toolTipId={fields.toolTipId}
              customStyles="compDetailsFormLabel"
              label={fields.fieldLabel}
              mandate={Constants.REQUIRED}
              toolTipText={fields.toolTipText}
            />
            <CurrencyInput
              className="form-control"
              placeholder={fields.placeHolder}
              maxLength={fields.maxLength}
              value={
                this.state?.mbeWbeVendorDetails[fields.fieldId] !== null
                  ? this.state?.mbeWbeVendorDetails[fields.fieldId]
                  : ""
              }
              transformRawValue={transformValue}
              onValueChange={(event) => {
                this.handleValidation(
                  fields.fieldId,
                  event === "000" || event === undefined ? null : event
                );
                this.onChangeMBEWBE(fields.fieldId, event);
              }}
              decimalsLimit={0}
              groupSeparator=","
              prefix="$"
              allowNegativeValue={false}
              onBlur={(event) =>
                this.handleValidation(
                  fields.fieldId,
                  this.state?.mbeWbeVendorDetails[fields.fieldId]
                )
              }
              disabled={
                this.props.vendorProfile?.vendorDetail?.isPrimaryVendor ===
                  false || this.isCompanyDetailsFlagRuleCompliant() === false
                  ? true
                  : false
              }
            />

            {this.state?.mbeWbeErrors[fields.fieldId] && (
              <div key={fields.fieldId} style={{ color: "#d64a4a" }}>
                {this.state?.mbeWbeErrors[fields.fieldId]}
              </div>
            )}
          </Form.Group>
        );
        break;
      case "select":
        field = (
          <Form.Group as={Col} md={4} key={index}>
            <ToolTip
              toolTipId={fields.toolTipId}
              customStyles="compDetailsFormLabel"
              label={fields.fieldLabel}
              mandate={fields.required && Constants.REQUIRED}
              toolTipText={fields.toolTipText}
            />
            <Form.Control
              as="select"
              id={fields.fieldId}
              onChange={(e) => {
                this.handleValidation(fields.fieldId, e.target.value);
                this.onChangeMBEWBE(fields.fieldId, e);
              }}
              value={this.state?.mbeWbeVendorDetails?.[fields.fieldId] || ""}
              onBlur={(e) =>
                this.handleValidation(fields.fieldId, e.target.value)
              }
              disabled={
                this.props.vendorProfile?.vendorDetail?.isPrimaryVendor ===
                  false || this.isCompanyDetailsFlagRuleCompliant() === false
                  ? true
                  : false
              }
            >
              {this.props?.configValues?.length > 0 && (
                <ConfigOptions
                  labelName={fields.fieldId}
                  configValues={this.props?.configValues}
                />
              )}
            </Form.Control>

            {this.state?.mbeWbeErrors[fields.fieldId] && (
              <div key={fields.fieldId} style={{ color: "#d64a4a" }}>
                {this.state?.mbeWbeErrors[fields.fieldId]}
              </div>
            )}
          </Form.Group>
        );
        break;
      case "searchSelect":
        field = (
          <Form.Group as={Col} md={4}>
            <ToolTip
              toolTipId={fields.toolTipId}
              customStyles="compDetailsFormLabel"
              label={fields.fieldLabel}
              mandate={fields.required && Constants.REQUIRED}
              toolTipText={fields.toolTipText}
            />
            <Select
              id={fields.fieldId}
              name={fields.fieldId}
              placeholder="Select all that apply"
              onChange={(e) => {
                fields.fieldId === "mbeGroups"
                  ? this.onChangeMBEGroups(e)
                  : this.onChangeOrganization(e);
              }}
              defaultValue={Constants.SELECT_ONE}
              isMulti
              isDisabled={
                (fields.fieldId === "mbeGroups" &&
                  (this.state?.mbeWbeVendorDetails?.mbeStatus === "NO" ||
                    this.state?.mbeWbeVendorDetails?.mbeStatus === null)) ||
                this.props.vendorProfile?.vendorDetail?.isPrimaryVendor ===
                  false ||
                this.isCompanyDetailsFlagRuleCompliant() === false
                  ? true
                  : false
              }
              options={this.getMultiSelectOptions(fields.fieldId)}
              value={
                this.state?.mbeWbeVendorDetails[fields.fieldId] !== null
                  ? this.getMultiSelectValue(fields.fieldId)
                  : null
              }
              onBlur={(e) =>
                this.getErrorSearchSelect(
                  this.state?.mbeWbeVendorDetails[fields.fieldId],
                  fields.fieldId
                )
              }
            />

            {this.state?.mbeWbeErrors[fields.fieldId] && (
              <div key={fields.fieldId} style={{ color: "#d64a4a" }}>
                {this.state?.mbeWbeErrors[fields.fieldId]}
              </div>
            )}
          </Form.Group>
        );
        break;
      case "radio":
        field = fields.option.map((option, ind) => {
          let optionField = {};
          optionField = (
            <Form.Check
              key={ind}
              id={fields.fieldId}
              type={fields.fieldType}
              name={fields.fieldId}
              label={option.optionName}
              value={option.optionValue}
              onChange={(e) => this.handleCheck(e)}
              checked={
                (option.optionValue === "documentUpload" &&
                !this.state.vendorDetails[fields.fieldId]
                  ? true
                  : false) ||
                (option.optionValue === "contractUpload" &&
                this.state.vendorDetails[fields.fieldId]
                  ? true
                  : false)
              }
              disabled={
                this.props.vendorProfile?.vendorDetail?.isPrimaryVendor ===
                  false || this.isCompanyDetailsFlagRuleCompliant() === false
                  ? true
                  : false
              }
            />
          );
          return optionField;
        });
        break;
      default:
        break;
    }
    return field;
  };

  getMultiSelectOptions = (fieldId) => {
    const configVal = this.props.configValues.filter(
      (config) => config.key === fieldId
    );
    const selectOptions = JSON.parse(
      configVal?.length > 0 && configVal[0].value
    );

    return selectOptions?.length > 0
      ? selectOptions.map((item) => ({
          value: item.name,
          label: item.value,
        }))
      : [];
  };

  getMultiSelectValue = (fieldId) => {
    const configVal = this.props.configValues.filter(
      (config) => config.key === fieldId
    );
    const selectOptions = JSON.parse(
      configVal?.length > 0 && configVal[0].value
    );

    let tempOpt = [];
    if (
      this.state?.mbeWbeVendorDetails?.[fieldId]?.length > 0 &&
      this.props.configValues?.length > 0
    ) {
      tempOpt = selectOptions.filter((o) => {
        return this.state?.mbeWbeVendorDetails?.[fieldId].some(
          (val) => o.name === val
        );
      });

      tempOpt = tempOpt.map((val) => {
        let selectedObj = {
          label: val["value"],
          value: val["name"],
        };

        return selectedObj;
      });
    }

    return tempOpt;
  };

  removeMBEWBEError = (key) => {
    let errorsObj = { ...this.state?.mbeWbeErrors };

    errorsObj[key] && delete errorsObj[key];

    this.setState({
      mbeWbeErrors: errorsObj,
    });
  };

  onChangeMBEWBE = (key, event) => {
    let mbeWbeVendorDetailsTemp = { ...this.state?.mbeWbeVendorDetails };

    if (key === "mbeStatus") {
      let mbeWbeErrorsTemp = { ...this.state?.mbeWbeErrors };
      delete mbeWbeErrorsTemp?.mbeGroups;
      mbeWbeVendorDetailsTemp["mbeGroups"] = null;
      mbeWbeVendorDetailsTemp[key] = event.target.value;

      this.setState({
        mbeWbeVendorDetails: mbeWbeVendorDetailsTemp,
        mbeWbeErrors: mbeWbeErrorsTemp,
      });
    } else {
      mbeWbeVendorDetailsTemp[key] =
        key === "avgEmployees"
          ? parseInt(event.target.value, 10)
          : key === "avgCompletedSales"
          ? event === "000" || event === undefined
            ? null
            : parseInt(event, 10)
          : key === "fax"
          ? formatPhone(event.target.value)
          : event.target.value;

      this.setState({
        mbeWbeVendorDetails: mbeWbeVendorDetailsTemp,
      });
    }
  };

  getErrorSearchSelect = (val, key) => {
    let errorsObj = { ...this.state?.mbeWbeErrors };

    if (val === null) {
      errorsObj[key] = `${key + " is Required"}`;
    } else {
      errorsObj[key] && delete errorsObj[key];
    }

    this.setState({
      mbeWbeErrors: errorsObj,
    });
  };

  onChangeMBEGroups = (event) => {
    let mbeWbeVendorDetailsTemp = { ...this.state?.mbeWbeVendorDetails };
    if (event) this.getErrorSearchSelect(event, "mbeGroups");

    mbeWbeVendorDetailsTemp["mbeGroups"] =
      event?.length > 0 ? event.map((item) => item.value) : null;

    this.setState({
      mbeWbeVendorDetails: mbeWbeVendorDetailsTemp,
    });
  };

  onChangeOrganization = (event) => {
    let mbeWbeVendorDetailsTemp = { ...this.state?.mbeWbeVendorDetails };
    if (event) this.getErrorSearchSelect(event, "organization");

    mbeWbeVendorDetailsTemp["organization"] =
      event?.length > 0 ? event.map((item) => item.value) : null;

    this.setState({
      mbeWbeVendorDetails: mbeWbeVendorDetailsTemp,
    });
  };

  validationSchema = yup.object({
    mbeStatus: yup
      .string()
      .required("MBE status is required")
      .test("Test digits", "Field is required as e.g Mike", (value) =>
        value.match(
          /^([A-Za-z](?!.*[-_]$)(?!.*[-_ ]{2})[a-zA-Z _-]*[A-Za-z ]*)$/g
        )
      ),
    wbeStatus: yup
      .string()
      .required("WBE status is required")
      .test("Test digits", "Field is required as e.g Smithe", (value) =>
        value.match(
          /^([A-Za-z](?!.*[-_]$)(?!.*[-_ ]{2})[a-zA-Z _-]*[A-Za-z ]*)$/g
        )
      ),
    mbeGroups: yup
      .array()
      .min(1, "Select atleast 1 MBE Group.")
      .required("MBE Groups is required"),
    ceoEmail: yup
      .string()
      .required("CEO email is required")
      .test((value) => {
        const regFlag = isEmailValid(value);

        if (!regFlag) {
          return new yup.ValidationError(
            Constants.VALID_EMAIL_ERROR_MSG,
            undefined,
            "email"
          );
        }

        return true;
      }),
    website: yup
      .string()
      .matches(
        /^($)|(https?:\/\/(?:www\.[^.])[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^.][^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^.][^\s]{2,}|https?:\/\/(?:www\.[^.])[a-zA-Z0-9]\.[^\s]{2,}|(www\.[^.])[a-zA-Z0-9]\.[^.][^\s]{2,})/,
        "Enter a valid website url"
      ),
    avgEmployees: yup
      .string()
      .required("Average number of employees is required only digits")
      .matches(/^[0-9]+$/, "Must be only digits"),
    avgCompletedSales: yup
      .string()
      .required("Average company sales is required only digits")
      .matches(/^[0-9]+$/, "Must be only digits"),
    federalId: yup
      .string()
      .matches(/^[0-9]\d{8}$/, "Please enter valid Federal Tax Id"),
    fax: yup.string().matches(/^[0-9]\d{9}$/, {
      message: "Please enter valid fax number.",
      excludeEmptyString: false,
    }),
  });

  handleValidation = (fieldId, fieldValue) => {
    yup
      .reach(this.validationSchema, `${[fieldId]}`)
      .validate(fieldValue)
      .then((value) => {
        let errorsObj = { ...this.state?.mbeWbeErrors };
        errorsObj[fieldId] && delete errorsObj[fieldId];

        this.setState({ mbeWbeErrors: errorsObj });
      })
      .catch((err) => {
        let errorsObj = {};
        errorsObj[fieldId] = err.message;

        this.setState({
          ...this.state.mbeWbeErrors,
          mbeWbeErrors: { ...this.state.mbeWbeErrors, ...errorsObj },
        });
      });
  };

  validateForm = () => {
    let validForm = false;
    const checkFields =
      this.state?.mbeWbeVendorDetails?.mbeStatus === "YES"
        ? [
            "mbeStatus",
            "mbeGroups",
            "wbeStatus",
            "ceoEmail",
            "organization",
            "avgEmployees",
            "avgCompletedSales",
          ]
        : [
            "mbeStatus",
            "wbeStatus",
            "ceoEmail",
            "organization",
            "avgEmployees",
            "avgCompletedSales",
          ];

    Object.keys(this.state?.mbeWbeVendorDetails).forEach((field) => {
      if (checkFields.includes(field)) {
        if (this.state?.mbeWbeVendorDetails[field] === null) {
          validForm = true;
        }
      }
    });

    return validForm;
  };

  render() {
    const pageAccessBasedOnRole =
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
        RolePermissionConstants.VMP_PAGEACCESS
      ) === RolePermissionConstants.VIEW;
    let isEditable = false;
    const isMPVendor =
      this.props.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE;
    let viewAddProdFulfillmentTypeBtn = false;

    if (
      this.props.vendorProfile &&
      this.props.vendorProfile.vendorDetail &&
      this.props.vendorProfile.vendorDetail.duns &&
      Validations.isValidDuns(this.props.vendorProfile.vendorDetail.duns) &&
      this.state.allowAddProdFulfillmentTypeBtn
    ) {
      viewAddProdFulfillmentTypeBtn = true;
    }

    if (
      !checkUserRoles([
        Constants.EXTERNAL_VENDOR_GENERIC,
        Constants.EXTERNAL_GENERIC_ADMIN,
      ]) &&
      !this.props.vendorProfileId
    ) {
      this.makeformDisable(document.forms.companyBasicDetails);
    } else if (
      RolePermissionConstants.EDIT ===
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
        RolePermissionConstants.ALL
      )
    ) {
      isEditable = true;
      if (this.props.vendorProfile) {
        const { primaryContact, vendorDetail } = this.props.vendorProfile;

        if (
          (primaryContact &&
            primaryContact.userEmail === this.props.userEmail &&
            vendorDetail &&
            vendorDetail.duns &&
            Validations.isValidDuns(vendorDetail.duns)) ||
          this.props.vendorProfile?.vendorDetail?.isPrimaryVendor === false
        ) {
          this.makeformDisable(document.forms.companyBasicDetails);
        } else {
          this.makeformEnable(document.forms.companyBasicDetails);
        }
      } else {
        this.makeformEnable(document.forms.companyBasicDetails);
      }
    } else {
      this.makeformDisable(document.forms.companyBasicDetails);
      this.makeformDisable(document.forms.companyDetails);
    }

    if (!this.props.extUserEnabled || isMPVendor) {
      isEditable = false;
      this.makeformDisable(document.forms.companyBasicDetails);
      this.makeformDisable(document.forms.companyDetails);
    }

    let companyDetailsFields = Fields.map((rows) => {
      return [...rows.map((field) => ({ ...field }))];
    });

    if (isMPVendor) {
      companyDetailsFields = companyDetailsFields.map((rows) => {
        return [
          ...rows.filter((field) =>
            ["merchandiseType", "certifiedAsMinority"].includes(field.fieldId)
          ),
        ];
      });
    }
    this.validator.purgeFields();

    return (
      <fieldset
        disabled={this.props.onboardingStatusFlag && !pageAccessBasedOnRole}
      >
        <Row>
          <Col md={12}>
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <div className="m-top-10">
                <ErrorContainer
                  errorMsg={this.state.errorMsg}
                  updateStatus={this.state.updateStatus}
                  successMsg={this.state.successMsg}
                  errorStatus={this.state.errorStatus}
                  errorStyle="errorMessage"
                  successStyle="successMessage"
                />
                <div className={`m-top-n20 ${isEditable ? "" : "disableView"}`}>
                  <Form name="companyBasicDetails">
                    <Form.Row>
                      <Form.Group as={Col} md={4}>
                        <ToolTip
                          toolTipId="toolTipCorpName"
                          customStyles="compDetailsFormLabel"
                          label={Constants.COMPANY_NAME_LABEL}
                          mandate={Constants.REQUIRED}
                          toolTipText={Constants.COMPANY_NAME_LABEL_HELP_TEXT}
                        />
                        <Form.Control
                          required
                          type="text"
                          id="vendorCorpName"
                          name="vendorCorpName"
                          placeholder={Constants.CORP_NAME_PLACE_HOLDER}
                          onChange={(e) => this.onChange("vendorCorpName", e)}
                          onBlur={() => this.showErrorMsg("vendorCorpName", 12)}
                          value={this.state.vendorCorpName || ""}
                          disabled={
                            (this.props.vendorProfile &&
                              this.props.vendorProfile.vendorDetail &&
                              this.props.vendorProfile.vendorDetail
                                .vendorCorpName !== null) ||
                            !this.props.extUserEnabled
                              ? true
                              : false
                          }
                          className={
                            this.state.hasErrorIndex === 12 ? "has-error" : ""
                          }
                        />
                        {this.showError(
                          "req",
                          "vendorCorpName",
                          this.state.vendorCorpName
                        )}
                        {this.state.isDunsValidated &&
                          this.state.isValidDunsNumber &&
                          this.state.hasErrorIndex !== 12 &&
                          ((!this.state.isVendorPresent &&
                            !this.state.isOwnVendorProfile) ||
                            (this.state.isVendorPresent &&
                              this.state.isOwnVendorProfile)) && (
                            <p className="validationSuccessMsg">
                              {this.state.corpValidationMsg}
                            </p>
                          )}
                      </Form.Group>
                      {this.state.isDunsValidated &&
                        this.state.isValidDunsNumber &&
                        this.state.hasErrorIndex !== 12 && (
                          <Form.Group>
                            <i className="checkMark"></i>
                          </Form.Group>
                        )}

                      <DunsWrapper
                        onChange={this.onChange}
                        dunsValidationStatus={this.getDunsValidationStatus()}
                        dunsErrorStatus={this.getErrorStatus()}
                        dunValidationMsg={this.state.dunValidationMsg}
                        dunValidationErrorMsg={this.state.dunValidationErrorMsg}
                        dunsErrorMessage={""}
                        duns={this.state.duns}
                        validateDunsAlreadyExist={this.validateDunsAlreadyExist}
                        isDunsValidated={this.state.isDunsValidated}
                        isValidDunsNumber={this.state.isValidDunsNumber}
                        dunsCheckMarkSatus={this.getDunsCheckMarkSatus()}
                        hasErrorIndex={this.state.hasErrorIndex}
                        disabled={
                          !this.validator.fieldValid("vendorCorpName") ||
                          !this.props.extUserEnabled
                        }
                        colSize={this.props.extUserEnabled ? 7 : 11}
                        hasValidateBtn={
                          this.props.extUserEnabled &&
                          this.props.merchandiseType !==
                            Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
                        }
                        reValidateFlag={
                          getUserRolePermission(
                            RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
                            RolePermissionConstants.VMP_REVALIDATE
                          ) !== RolePermissionConstants.NONE
                        }
                      />

                      {this.props.extUserEnabled && (
                        <Row>
                          {_.isEmpty(this.state.duns) &&
                            _.isEmpty(this.state.vendorCorpName) && (
                              <Form.Label className="dunsCreationInfoMsg">
                                {" "}
                                {Constants.DUNS_CREATION_BY_MACYS_MSG}
                              </Form.Label>
                            )}
                        </Row>
                      )}
                      {!this.props.extUserEnabled &&
                        verifyAccessPermission("initialAddressPopup") && (
                          <Row>
                            <Col xs={10} className="px-2">
                              <p className="font-weight-bold">
                                <ExternalCompanyDetailsModal
                                  closeHandler={this.externalVendorHandler}
                                  externalVendorModal={
                                    this.state.externalVendorModal
                                  }
                                />
                                <span className="errorMessage">
                                  {
                                    Constants.VOB_EXT_VENDOR_REGISTRATION_PROCESSING_MSG_PREFIX
                                  }
                                </span>
                                <span>
                                  {
                                    Constants.VOB_EXT_VENDOR_REGISTRATION_PROCESSING_MSG
                                  }
                                </span>
                              </p>
                            </Col>
                          </Row>
                        )}
                    </Form.Row>
                  </Form>
                </div>
                {this.state.isDunsValidated &&
                  ((!this.state.isVendorPresent &&
                    !this.state.isOwnVendorProfile) ||
                    (this.state.isVendorPresent &&
                      this.state.isOwnVendorProfile)) && (
                    <div className={`${isEditable ? "" : "disableView"}`}>
                      <Form name="companyDetails">
                        <div className="clsBrandContainer">
                          {this.state.brandErrors && (
                            <OnSubmitErrorMessage
                              type="error"
                              message="Each Brand Name and URL must be unique"
                            />
                          )}
                          {this.state.brandRecords.map((brandRecord, index) => {
                            return (
                              <Form.Row key={index}>
                                <Form.Group
                                  as={Col}
                                  md={CompanyBrandName.length}
                                >
                                  <ToolTip
                                    toolTipId={CompanyBrandName.toolTipId}
                                    customStyles="compDetailsFormLabel"
                                    label={CompanyBrandName.fieldLabel}
                                    mandate={Constants.REQUIRED}
                                    toolTipText={CompanyBrandName.toolTipText}
                                  />
                                  <Form.Control
                                    type={CompanyBrandName.fieldType}
                                    placeholder={CompanyBrandName.placeHolder}
                                    id={CompanyBrandName.fieldId + index}
                                    automationid={
                                      CompanyBrandName.fieldId + index
                                    }
                                    name={CompanyBrandName.fieldId + index}
                                    onBlur={(e) => {
                                      this.showErrorMsg(
                                        CompanyBrandName.fieldId + index,
                                        index,
                                        e
                                      );
                                    }}
                                    onChange={(e) => {
                                      this.changeHandlerForBrand(
                                        e,
                                        index,
                                        CompanyBrandName.fieldId
                                      );
                                      this.validateDuplicateBrand(e, index);
                                    }}
                                    value={
                                      brandRecord[CompanyBrandName.fieldId] ||
                                      ""
                                    }
                                  />
                                  {this.showError(
                                    CompanyBrandName.validateType,
                                    CompanyBrandName.fieldId + index,
                                    brandRecord[CompanyBrandName.fieldId]
                                  )}
                                </Form.Group>
                                {!isMPVendor && (
                                  <>
                                    <Form.Group
                                      as={Col}
                                      md={CompanyBrandUrl.length}
                                    >
                                      <ToolTip
                                        toolTipId={CompanyBrandUrl.toolTipId}
                                        customStyles="compDetailsFormLabel"
                                        label={CompanyBrandUrl.fieldLabel}
                                        toolTipText={
                                          CompanyBrandUrl.toolTipText
                                        }
                                      />
                                      <Form.Control
                                        type={CompanyBrandUrl.fieldType}
                                        placeholder={
                                          CompanyBrandUrl.placeHolder
                                        }
                                        id={CompanyBrandUrl.fieldId + index}
                                        automationid={
                                          CompanyBrandUrl.fieldId + index
                                        }
                                        name={CompanyBrandUrl.fieldId + index}
                                        onBlur={(e) => {
                                          this.showErrorMsg(
                                            CompanyBrandUrl.fieldId + index,
                                            index,
                                            e
                                          );
                                        }}
                                        onChange={(e) => {
                                          this.brandURLChangeHandler(
                                            e,
                                            index,
                                            CompanyBrandUrl.fieldId
                                          );
                                          this.validateDuplicateBrand(e, index);
                                        }}
                                        value={
                                          brandRecord[
                                            CompanyBrandUrl.fieldId
                                          ] || ""
                                        }
                                      />
                                      {this.showError(
                                        CompanyBrandUrl.validateType,
                                        CompanyBrandUrl.fieldId + index,
                                        brandRecord[CompanyBrandUrl.fieldId]
                                      )}
                                    </Form.Group>
                                    <Form.Group
                                      as={Col}
                                      md={DeleteBrand.length}
                                      className="p-top-20"
                                    >
                                      <Form.Row>
                                        <div
                                          automationid="addMoreBrands"
                                          onClick={(e) => {
                                            getUserRolePermission(
                                              RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
                                              RolePermissionConstants.VMP_ADDMORE
                                            ) ===
                                              RolePermissionConstants.EDIT &&
                                              this.addBrand(e);
                                          }}
                                          className="add"
                                          style={{
                                            pointerEvents:
                                              this.props.onboardingStatusFlag &&
                                              !pageAccessBasedOnRole &&
                                              "none",
                                            color:
                                              this.props.onboardingStatusFlag &&
                                              !pageAccessBasedOnRole &&
                                              "grey",
                                          }}
                                        >
                                          + Add More
                                        </div>
                                      </Form.Row>
                                      {this.state.brandRecords.length > 1 && (
                                        <Form.Row>
                                          <div
                                            automationid={DeleteBrand.fieldId}
                                            onClick={(e) => {
                                              this.removeHandler(e, index);
                                            }}
                                            className="delete"
                                            style={{
                                              pointerEvents:
                                                this.props
                                                  .onboardingStatusFlag &&
                                                !pageAccessBasedOnRole &&
                                                "none",
                                              color:
                                                this.props
                                                  .onboardingStatusFlag &&
                                                !pageAccessBasedOnRole &&
                                                "grey",
                                            }}
                                          >
                                            {DeleteBrand.fieldLabel}
                                          </div>
                                        </Form.Row>
                                      )}
                                    </Form.Group>
                                  </>
                                )}
                              </Form.Row>
                            );
                          })}
                        </div>
                        <div>
                          {this.props?.configValues?.length > 0 &&
                            companyDetailsFields.map((rows, rowIndex) => {
                              return (
                                <Form.Row
                                  key={rowIndex}
                                  style={{
                                    maxHeight: rowIndex === 2 ? 60 : "",
                                  }}
                                >
                                  {rows.map((fields, index) => {
                                    let field = {};
                                    switch (fields.fieldType) {
                                      case "text":
                                        field = (
                                          <Form.Group
                                            as={Col}
                                            md={4}
                                            key={index}
                                          >
                                            {fields.toolTipId && (
                                              <ToolTip
                                                toolTipId={fields.toolTipId}
                                                customStyles="compDetailsFormLabel"
                                                label={fields.fieldLabel}
                                                mandate={
                                                  fields.fieldId !==
                                                  Constants.OPEN_RAN_NUM
                                                    ? Constants.REQUIRED
                                                    : ""
                                                }
                                                toolTipText={fields.toolTipText}
                                              />
                                            )}
                                            {!fields.toolTipId && (
                                              <Form.Label>
                                                {fields.fieldLabel}
                                              </Form.Label>
                                            )}
                                            <Form.Control
                                              type={fields.fieldType}
                                              placeholder={fields.placeHolder}
                                              id={fields.fieldId}
                                              name={fields.fieldId}
                                              maxLength={fields.maxLength}
                                              onBlur={(e) =>
                                                this.showErrorMsg(
                                                  fields.fieldId,
                                                  index,
                                                  e
                                                )
                                              }
                                              onChange={(e) =>
                                                this.onChange(fields.fieldId, e)
                                              }
                                              value={
                                                fields.fieldId.indexOf("Upc") >
                                                -1
                                                  ? this.state
                                                      .numberOfUpcToDropShip
                                                  : !_.isEmpty(
                                                      this.state.vendorDetails[
                                                        fields.fieldId
                                                      ]
                                                    )
                                                  ? this.state.vendorDetails[
                                                      fields.fieldId
                                                    ]
                                                  : this.state.merchantContact[
                                                      fields.fieldId
                                                    ]
                                              }
                                            />
                                            {this.showError(
                                              fields.validateType,
                                              fields.fieldId,
                                              !_.isEmpty(
                                                this.state.vendorDetails[
                                                  fields.fieldId
                                                ]
                                              )
                                                ? this.state.vendorDetails[
                                                    fields.fieldId
                                                  ]
                                                : this.state.merchantContact[
                                                    fields.fieldId
                                                  ]
                                            )}
                                          </Form.Group>
                                        );

                                        break;
                                      case "select":
                                        field = (fields.fieldId !==
                                          Constants.VENDOR_COMPANY_TYPE ||
                                          (fields.fieldId ===
                                            Constants.VENDOR_COMPANY_TYPE &&
                                            this.state?.vendorDetails
                                              ?.merchandiseType ===
                                              Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT)) && (
                                          <Form.Group
                                            as={Col}
                                            md={4}
                                            key={index}
                                          >
                                            <ToolTip
                                              toolTipId={fields.toolTipId}
                                              customStyles="compDetailsFormLabel"
                                              label={fields.fieldLabel}
                                              mandate={Constants.REQUIRED}
                                              toolTipText={fields.toolTipText}
                                            />
                                            <Form.Control
                                              as="select"
                                              id={fields.fieldId}
                                              onChange={(e) =>
                                                this.onChange(fields.fieldId, e)
                                              }
                                              value={
                                                this.state.vendorDetails[
                                                  fields.fieldId
                                                ] || ""
                                              }
                                              disabled={
                                                !isEditable ||
                                                (fields.fieldId ===
                                                  "merchandiseType" &&
                                                this.props.profileTypeDetails
                                                  .length > 1
                                                  ? true
                                                  : false) ||
                                                (fields.fieldId ===
                                                  "merchandiseType" &&
                                                  this.props
                                                    .onboardStatusBeyondInprocessStatusFlag)
                                              }
                                              onBlur={(e) =>
                                                this.showErrorMsg(
                                                  fields.fieldId,
                                                  index,
                                                  e
                                                )
                                              }
                                            >
                                              <DynamicOptions
                                                labelName={fields.fieldId}
                                                selectedValue={
                                                  this.state.vendorDetails[
                                                    fields.fieldId
                                                  ]
                                                }
                                                responseValue={
                                                  this.props?.vendorProfile
                                                    ?.vendorDetail?.[
                                                    fields.fieldId
                                                  ]
                                                }
                                                configValues={
                                                  this.props?.configValues
                                                }
                                              />
                                            </Form.Control>
                                            {this.showError(
                                              fields.validateType,
                                              fields.fieldId,
                                              this.state.vendorDetails[
                                                fields.fieldId
                                              ]
                                            )}
                                          </Form.Group>
                                        );
                                        break;
                                      case "isUPSEnabled":
                                        field = (
                                          <Form.Group
                                            key={index}
                                            as={Row}
                                            controlId={fields.fieldId}
                                            style={{
                                              display: "flex",
                                            }}
                                          ></Form.Group>
                                        );
                                        break;
                                      case "radio":
                                        field = (
                                          <Form.Group
                                            key={index}
                                            controlId={fields.fieldId}
                                            style={{
                                              display: "flex",
                                            }}
                                          >
                                            <Row>
                                              <Row>
                                                <Form.Label className="certiFiedMinorityLabel col-sm-12 pt ">
                                                  <div>
                                                    <div
                                                      style={{
                                                        maxWidth: "670px",
                                                      }}
                                                    >
                                                      {fields.fieldLabel}
                                                      <span className="srv-validation-message">
                                                        *
                                                      </span>
                                                    </div>
                                                    <div className="flexContainer">
                                                      {fields.option.map(
                                                        (option, index) => {
                                                          let optionField = {};
                                                          optionField = (
                                                            <Form.Check
                                                              key={index}
                                                              className="paddingRight15 mt-1 normalFontWeight"
                                                              type={
                                                                fields.fieldType
                                                              }
                                                              name={
                                                                fields.fieldId
                                                              }
                                                              id={
                                                                fields.fieldId
                                                              }
                                                              onChange={(e) =>
                                                                this.handleCheck(
                                                                  e
                                                                )
                                                              }
                                                              onBlur={(e) =>
                                                                this.showErrorMsg(
                                                                  fields.fieldId,
                                                                  index,
                                                                  e
                                                                )
                                                              }
                                                              value={
                                                                option.optionValue
                                                              }
                                                              disabled={
                                                                this.props
                                                                  .vendorProfile
                                                                  ?.vendorDetail
                                                                  ?.isPrimaryVendor ===
                                                                  false ||
                                                                this.isCompanyDetailsFlagRuleCompliant() ===
                                                                  false
                                                                  ? true
                                                                  : false
                                                              }
                                                              checked={
                                                                (option.optionValue ===
                                                                  Constants.YES &&
                                                                this.state
                                                                  .vendorDetails[
                                                                  fields.fieldId
                                                                ] === true
                                                                  ? true
                                                                  : false) ||
                                                                (option.optionValue ===
                                                                  Constants.NO &&
                                                                this.state
                                                                  .vendorDetails[
                                                                  fields.fieldId
                                                                ] === false
                                                                  ? true
                                                                  : false)
                                                              }
                                                              label={
                                                                option.optionValue
                                                              }
                                                            />
                                                          );
                                                          return optionField;
                                                        }
                                                      )}
                                                      {this.props.vendorProfile
                                                        ?.vendorDetail
                                                        ?.isPrimaryVendor !==
                                                        false &&
                                                        this.showError(
                                                          fields.validateType,
                                                          fields.fieldId,
                                                          this.state
                                                            .vendorDetails[
                                                            fields.fieldId
                                                          ]
                                                        )}
                                                    </div>
                                                  </div>
                                                </Form.Label>
                                              </Row>
                                            </Row>
                                          </Form.Group>
                                        );
                                        break;
                                      default:
                                        break;
                                    }
                                    return field;
                                  })}
                                </Form.Row>
                              );
                            })}
                          <Form.Row className="MBEWBEContractCheck">
                            {this.state?.vendorDetails?.certifiedAsMinority &&
                              !isMPVendor &&
                              MBEWBEContractCheck?.map((fields, index) => {
                                return this.getFields(fields, index);
                              })}
                          </Form.Row>
                          <Form.Row
                            className={
                              this.state?.vendorDetails?.certifiedAsMinority &&
                              this.state?.vendorDetails?.isAffidavit &&
                              "MBEWBESection"
                            }
                          >
                            {this.state?.vendorDetails?.certifiedAsMinority &&
                              this.state?.vendorDetails?.isAffidavit &&
                              !isMPVendor &&
                              MBEWBEFields.map((fields, index) => {
                                return this.getFields(fields, index);
                              })}
                          </Form.Row>
                        </div>

                        <div className="marginTop50">
                          <div className="border-b pt-3 col-md-12"></div>
                          <Form.Group
                            className={`vob-btn-group-company mt-3 d-flex justify-content-${
                              viewAddProdFulfillmentTypeBtn ||
                              this.isCompanyApproveDenyButtonVisible()
                                ? "between"
                                : "end"
                            }`}
                          >
                            {this.isCompanyApproveDenyButtonVisible() && (
                              <>
                                <Button
                                  id="companyApproveDenyBtn"
                                  className="button-primary-md"
                                  onClick={() => {
                                    this.getMbeWbeExpireDate();
                                    this.setState({
                                      showApproveDenyModel: true,
                                      expirationErrorMsg: "",
                                    });
                                  }}
                                >
                                  {Constants.APPROVE_DENY}
                                </Button>
                                {this.state?.vendorDetails
                                  ?.certifiedAsMinority && (
                                  <ConfirmationModal
                                    show={this.state.showApproveDenyModel}
                                    onOk={() => {
                                      this.handleDEIApproval("Approve");
                                      this.setState({
                                        showApproveDenyModel: false,
                                      });
                                    }}
                                    onDeny={() =>
                                      this.handleDEIApproval("Deny")
                                    }
                                    onCancel={() =>
                                      this.setState({
                                        showApproveDenyModel: false,
                                      })
                                    }
                                    confirmationTitle={
                                      Constants.DEI_APPROVAL_CONFIRMATION_TITLE
                                    }
                                    onActionInProgress={
                                      !this.state?.mbeWbeExpireDate || false
                                    }
                                    confirmationText={
                                      <div>
                                        <p className="confirmationModal_bodyText1">
                                          {
                                            Constants.DEI_APPROVAL_CONFIRMATION_TEXT
                                          }
                                        </p>
                                        <p className="confirmationModal_bodyText2">
                                          <span className="lbl_bodyText2">
                                            {
                                              Constants.DEI_EXP_DATE_CERT_AFFIDAVIT
                                            }
                                          </span>
                                          <span className="field_bodyText2">
                                            <Form.Control
                                              type={"date"}
                                              id={"mbeWbeExpireDateId"}
                                              name={"mbeWbeExpireDate"}
                                              min={
                                                new Date().getFullYear() +
                                                "-" +
                                                (new Date().getMonth() + 1)
                                                  .toString()
                                                  .padStart(2, "0") +
                                                "-" +
                                                new Date()
                                                  .getDate()
                                                  .toString()
                                                  .padStart(2, "0")
                                              }
                                              max={
                                                new Date().getFullYear() +
                                                200 +
                                                "-" +
                                                (new Date().getMonth() + 1)
                                                  .toString()
                                                  .padStart(2, "0") +
                                                "-" +
                                                new Date()
                                                  .getDate()
                                                  .toString()
                                                  .padStart(2, "0")
                                              }
                                              value={
                                                this.state?.mbeWbeExpireDate ||
                                                ""
                                              }
                                              disabled={
                                                this.state?.vendorDetails
                                                  ?.isAffidavit || false
                                              }
                                              onChange={(e) =>
                                                this.handleChangeMbeWbeExpDateField(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </span>
                                        </p>
                                        <p>
                                          <div style={{ color: "red" }}>
                                            {this.state?.expirationErrorMsg}
                                          </div>
                                        </p>
                                        <p className="confirmationModal_bodyNote">
                                          {
                                            Constants.DEI_NOTE_EXP_DATE_CERT_AFFIDAVIT
                                          }
                                        </p>
                                      </div>
                                    }
                                    okButtonText="Approve"
                                    cancelButtonText="Deny"
                                    forApproveDeny={true}
                                  />
                                )}

                                {this.state?.vendorDetails
                                  ?.certifiedAsMinority === false && (
                                  <ConfirmationModal
                                    show={this.state.showApproveDenyModel}
                                    onOk={() => {
                                      this.handleDEIApproval("Deny");
                                      this.setState({
                                        showApproveDenyModel: false,
                                      });
                                    }}
                                    onCancel={() =>
                                      this.setState({
                                        showApproveDenyModel: false,
                                      })
                                    }
                                    confirmationTitle={
                                      Constants.DEI_APPROVAL_CONFIRMATION_TITLE
                                    }
                                    confirmationText={
                                      Constants.DEI_APP_NO_OPT_CONFIRM_TXT
                                    }
                                    okButtonText="OKAY"
                                    cancelButtonText=""
                                    forApproveDeny={true}
                                    cancelNotRequired={true}
                                  />
                                )}
                              </>
                            )}

                            {viewAddProdFulfillmentTypeBtn && (
                              <Button
                                id="companyAddProdFulfillmentTypeBtn"
                                disabled={
                                  !checkUserRoles([
                                    Constants.EXTERNAL_VENDOR_GENERIC,
                                    Constants.EXTERNAL_GENERIC_ADMIN,
                                  ])
                                }
                                className="button-primary-md button-primary-auto"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState({
                                    showAddSecondUserModal: true,
                                    canVendorInitiate: true,
                                  });
                                }}
                              >
                                {Constants.ADDITIONAL_PRODUCT_FULFILLMENT_TYPE}
                              </Button>
                            )}
                            <Button
                              id="companyContBtn"
                              disabled={
                                !this.validator.allValid() ||
                                this.state.brandErrors ||
                                this.state.dunValidationErrorMsg ||
                                this.state.disableContinueButton ||
                                (this.state?.vendorDetails
                                  ?.certifiedAsMinority &&
                                  this.state?.vendorDetails?.isAffidavit &&
                                  (!(
                                    Object.entries(this.state?.mbeWbeErrors)
                                      .length === 0 &&
                                    this.state?.mbeWbeErrors.constructor ===
                                      Object
                                  ) ||
                                    this.validateForm()))
                              }
                              className="button-primary-md"
                              onClick={(event) => this.handleSubmit(event)}
                            >
                              {Constants.BUTTON_CONTINUE}
                            </Button>
                          </Form.Group>
                        </div>
                      </Form>
                    </div>
                  )}
              </div>
            )}
            {this.state.rolePermissionStatus &&
              this.state.rolePermissionStatus ===
                RolePermissionConstants.NONE && (
                <div>
                  <ErrorContainer
                    errorMsg={
                      RolePermissionConstants.VMP_COMPANYDETAILS_PAGE_ACCESS_ERROR_MSG
                    }
                    errorStatus={this.state.rolePermissionStatus}
                    errorStyle="errorMessage"
                  />
                </div>
              )}
            {this.state.showAddSecondUserModal && (
              <AddSecondUserModal
                closeHandler={this.addSecondUserModalCloseHandler}
                corpName={this.state.vendorCorpName}
                dunsNo={this.state.duns}
                canVendorInitiate={this.state.canVendorInitiate}
              />
            )}
          </Col>
        </Row>
      </fieldset>
    );
  }
}

const mapStateToProps = ({ service, common }) => ({
  vendorProfile: service.vendorProfile || {},
  vendorProfileId: service.vendorProfile?.vendorDetail?.id || "",
  userEmail: !checkUserRoles([Constants.EXTERNAL_VENDOR_GENERIC])
    ? common.userEmail
    : Cookies.get("email")
    ? Cookies.get("email").toLowerCase()
    : "",
  duns: common.duns,
  status: common.boardingStatuses,
  profileTypeDetails: service.vendorProfile?.profileTypeDetails || [],
  vendorStatus: service.vendorStatus || [],
  merchantContact: service.merchantContact,
  configValues: common?.configValues,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updateCommonInfo: (data) => dispatch(updateCommonInfo(data)),
    updateVendorProfileDetails: (data) =>
      dispatch(updateVendorProfileDetails(data)),
    updateMerchantDetails: (data) => dispatch(updateMerchantDetails(data)),
    updateServiceData: (data) => dispatch(updateServiceData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Company);
